import {useQuery} from 'react-query';
import {getCompteDB} from '../Api/api';
import {DBService} from '../Types/service';

export const useGetDatabase = (customer: string, enabled: boolean = true) => {
  return useQuery<any, any, DBService[]>(
    ['database', customer],
    async () => getCompteDB(customer),
    {
      enabled,
    }
  );
};
